import { render, staticRenderFns } from "./AboutSystemView.vue?vue&type=template&id=86593ece&scoped=true"
import script from "./AboutSystemView.vue?vue&type=script&lang=js"
export * from "./AboutSystemView.vue?vue&type=script&lang=js"
import style0 from "./AboutSystemView.vue?vue&type=style&index=0&id=86593ece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86593ece",
  null
  
)

export default component.exports